import BaseFolder from './BaseFolder';

// @interface fetchStatus
class ReportFolder_TrackFetchStatus extends BaseFolder {
  constructor(params) {
    super(params);
    // Indicates if reports belong to this folder have been fetched
    const { isReportsFetched = false } = params;
    this.isReportsFetched = isReportsFetched;
  }

  setFetchStatus(val = true) {
    this.isReportsFetched = val;
  }

  isFetched() {
    return this.isReportsFetched;
  }
}

export default ReportFolder_TrackFetchStatus;



// WEBPACK FOOTER //
// ./src/models/Reports/ReportFolder_TrackFetchStatus.js